import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';

import Styles from './styles.module.scss';
import tempDataLanguage from '../../../data/tempDataLanguage';
import withComponentName from '../../../decorators/withComponentName';

const LanguagesTableComponent = () => (
  <div className={Styles.table_container}>
    {tempDataLanguage.map((item, index) => (
      <div key={index} className={Styles.actual_storie}>
        <div className={Styles.article_body}>
          <img src={item.image} className={Styles.article_image} alt="" />
          <div className={Styles.article_content}>
            <div className={Styles.article_content_name}>
              {item.item_name}
            </div>
            <div className={Styles.article_content_wraper}>
              <div className={Styles.article_content_lable}>
                <div className={Styles.article_content_lable_img}>
                  {item.img_tweeter && (
                    <FontAwesomeIcon className="mr-1" icon={faTwitter} />
                  )}
                </div>
                <div className={Styles.article_content_lable_text}>{item.lable}</div>
              </div>
              <div className={Styles.article_content_time}>
                {item.hour}
                hours ago
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.article_ratio}>
          <div className={Styles.article_retweet}>
            <div className={Styles.article_ratio_retweet_background}>
              <i className={Styles.icon_retweets_article} />
            </div>
            <div className={Styles.article_ratio_retweet_number}>
              {item.ratio_retweet}
            </div>
          </div>
          <div className={Styles.article_ratio_score}>
            <span>
              {item.percent}
              %
            </span>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default withComponentName(LanguagesTableComponent);
